"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var CTAButton = function CTAButtonComponent(_ref) {
  var sliceData = _ref.sliceData,
      dataClient = _ref.dataClient;

  if (!sliceData[0].cta_link.url) {
    return null;
  }

  return sliceData.map(function (_ref2) {
    var cta_type = _ref2.cta_type,
        cta_text = _ref2.cta_text,
        cta_link = _ref2.cta_link;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "info-list__cta-wrapper",
      key: cta_link.url
    }, /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
      href: cta_link.url,
      external: cta_link.target === '_blank',
      className: "info-list__cta-".concat(cta_type.toLowerCase())
    }, dataClient.textToMarkdown(cta_text)));
  });
};

CTAButton.propTypes = {
  sliceData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    cta_type: _propTypes["default"].string,
    cta_text: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    cta_link: _propTypes["default"].shape({})
  })).isRequired,
  dataClient: _propTypes["default"].shape({}).isRequired
};
var _default = CTAButton;
exports["default"] = _default;